import { useCallback } from 'react';

import { link } from '@aline/routes';
import { useNavigate } from 'react-router-dom';
import { useDispatchSuccessSnack } from 'src/helpers';
import { useCreatePlaybook } from 'src/hooks';

/**
 * Creates an empty playbook and opens it in the playbooks editor. Shared by
 * the list "New playbook" button and the document drawer's "Create Playbook"
 * button so the two cannot drift apart.
 */
export function useCreatePlaybookAndEdit() {
  const navigate = useNavigate();
  const { createPlaybook, loading } = useCreatePlaybook();
  const dispatchCreatedSnack = useDispatchSuccessSnack({
    message: 'Playbook created.',
  });

  const createPlaybookAndEdit = useCallback(async () => {
    const { data } = await createPlaybook({
      variables: { input: { props: { description: '', title: '' } } },
    });
    if (!data) return;

    dispatchCreatedSnack();
    navigate(link.PlaybooksDetail({ playbookId: data.createPlaybook.id }));
  }, [createPlaybook, dispatchCreatedSnack, navigate]);

  return { createPlaybookAndEdit, loading };
}
